
















import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import WarningImg from '@/service/WarningImg'
export default Vue.extend({
  data() {
    return {
      warnimg: '',
      warntitle: '',
      warninfo: '',
    }
  },
  created() {
    this.getWarninfoData()
  },
  methods: {
    getWarninfoData() {
      const s = moment(new Date()).add(-1, 'd').format('YYYYMMDDHHmmss')
      const e = moment(new Date()).format('YYYYMMDDHHmmss')
      const params = {
        areaIds: config.defaultStationObj.adminCode,
        endtime: e,
        // startTime: '2021-05-31',
        // endTime: '2021-05-31',
      }
      console.log(params)
      // request.get('/warninfo/getEarlyWarnNewInfo', params).then((res) => {
      request.get('/warninfo/warn_info/list', params).then(res => {
        // console.log(res)
        if (res.length > 0) {
          const warnObj = res[0]
          // console.log(warnObj)
          this.warnimg = WarningImg.getImgSrc(`${warnObj.signaltype}${warnObj.signallevel}`)
          this.warntitle = `${warnObj.signaltype}${warnObj.signallevel}预警`
          this.warninfo = warnObj.issuecontent
        } else {
          this.warninfo = ''
        }
      }).catch((err) => {
        console.log(err)
      })
    },
  },
  filters: {
  },
})
